import { CallAPI } from "../../apiManager/ApiCall";
import { getReportURL, getMapReportURL } from "../../apiManager/APIConfig";
import { setReport, setMapReport } from "../../redux/slices/reportSlice";
import { store } from "../../redux/store";

export const GetDashboardReportCall = async () => {
  try {
    const response = await CallAPI({
      url: `${getReportURL}`,
      method: "GET",
    });
    console.log("pippo response", response);

    if (!response?.status) {
      store.dispatch(setReport(response));
      return response;
    } else {
      return response;
    }
  } catch (error) {
    return { status: 400 };
  }
};

export const GetMapReportCall = async () => {
  try {
    const response = await CallAPI({
      url: `${getMapReportURL}`,
      method: "GET",
    });

    if (response?.status == 200) {
      console.log("pippo response", response);

      store.dispatch(setMapReport(response));
      return response;
    } else {
      return response;
    }
  } catch (error) {
    return { status: 400 };
  }
};
